import messageReceivedSound from "../../assets/message-received.mp3";
import playerTurnSound from "../../assets/player-turn.wav";
import {Howl, Howler} from 'howler';

class AppSound {
    constructor(src, opts) {
        this.src = src;
        this.inner = new Howl({ src: [this.src], volume: 0.0 });
        this.minDelayBetweenPlays = opts?.minDelayBetweenPlays ?? 0;
        this.lastPlayedAt = null;
    }

    play(volume) {
        if (this.lastPlayedAt && Date.now() - this.lastPlayedAt < this.minDelayBetweenPlays) {
            return;
        }
        this.lastPlayedAt = Date.now();
        const id = this.inner.play();
        this.inner.volume(volume, id);
    }
}

export const MESSAGE_RECEIVED_SOUND = new AppSound(messageReceivedSound, { minDelayBetweenPlays: 5000 });
export const PLAYER_TURN_SOUND = new AppSound(playerTurnSound, { minDelayBetweenPlays: 1000 });